import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'

const investorRiskProfileFields: FieldInterface[] = [
  {
    key: 'label',
    originKey: 'label',
    type: FIELD_TYPES.string,
  },
  {
    key: 'score',
    originKey: 'score',
    type: FIELD_TYPES.number,
  },
  {
    key: 'piLabel',
    originKey: 'pi_label',
    type: FIELD_TYPES.string,
    objectType: 'InvestorProfileApiLabel',
    objectTypePath:
      'src/tpbp-json-api-handler/investor-profile/investor-profile.api.types.ts',
  },
  {
    key: 'piRequiresUpdate',
    originKey: 'pi_requires_update',
    type: FIELD_TYPES.string,
  },
  {
    key: 'piScore',
    originKey: 'pi_score',
    type: FIELD_TYPES.number,
  },
  {
    key: 'piUpdatedAt',
    originKey: 'pi_updated_at',
    type: FIELD_TYPES.string,
  },
  {
    key: 'qceCode',
    originKey: 'qce_code',
    type: FIELD_TYPES.string,
  },
  {
    key: 'qceLabel',
    originKey: 'qce_label',
    type: FIELD_TYPES.string,
  },
  {
    key: 'qceRequiresUpdate',
    originKey: 'qce_requires_update',
    type: FIELD_TYPES.string,
  },
  {
    key: 'qceScore',
    originKey: 'qce_score',
    type: FIELD_TYPES.number,
  },
  {
    key: 'qceUpdatedAt',
    originKey: 'qce_updated_at',
    type: FIELD_TYPES.string,
  },
  {
    key: 'updatedAt',
    originKey: 'updated_at',
    type: FIELD_TYPES.string,
  },
  {
    key: 'isPiUpdatable',
    originKey: 'pi_is_updatable',
    type: FIELD_TYPES.boolean,
  },
  {
    key: 'isQceUpdatable',
    originKey: 'qce_is_updatable',
    type: FIELD_TYPES.boolean,
  },
  {
    key: 'isEsgUpdatable',
    originKey: 'esg_is_updatable',
    type: FIELD_TYPES.boolean,
  },
  {
    key: 'isUpdatable',
    originKey: 'is_updatable',
    type: FIELD_TYPES.boolean,
  },
  {
    key: 'mustUpdateQualification',
    originKey: 'requires_update',
    type: FIELD_TYPES.boolean,
  },
  {
    key: 'riskInterval',
    originKey: 'risk_interval',
    type: FIELD_TYPES.object,
    objectType: 'RiskInterval',
    objectTypePath:
      'src/services/mappings/investorRiskProfile/investorRiskProfile.types',
  },
  {
    key: 'esgScore',
    originKey: 'esg_score',
    type: FIELD_TYPES.number,
  },
  {
    key: 'esgLabel',
    originKey: 'esg_label',
    type: FIELD_TYPES.string,
  },
  {
    key: 'esgRequiresUpdate',
    originKey: 'esg_requires_update',
    type: FIELD_TYPES.boolean,
  },
  {
    key: 'isUpToDate',
    originKey: 'is_up_to_date',
    type: FIELD_TYPES.boolean,
  },
  {
    key: 'requiresUpdate',
    originKey: 'requires_update',
    type: FIELD_TYPES.boolean,
  },
  {
    key: 'esgExtra',
    originKey: 'esg_extra',
    type: FIELD_TYPES.object,
    objectType: 'EsgExtra',
    objectTypePath: 'src/tpbp-json-api-handler/esg/esg.api.types.ts',
  },
]

const investorRiskProfileRelations: RelationInterface[] = [
  {
    key: '_esgQualifications',
    originKey: 'esg_qualification',
    objectType: OBJECT_TYPES.qualifications,
    isMultiple: false,
  },
]

export { investorRiskProfileFields, investorRiskProfileRelations }
